import {AwsS3MultipartOptions} from "@uppy/aws-s3-multipart";
import {getApiClient} from "../../../apiClient";


export default function createMultipartUpload(authToken: string): AwsS3MultipartOptions['createMultipartUpload'] {
  const apiClient = getApiClient(authToken)
  return (file) => apiClient.createMultipartUpload(file.name);
}
